<app-shared-dialog [title]="isUpdateMode ? ('custom_fields.edit_custom_field' | translate) : ('custom_fields.new_custom_field' | translate)" 
  [options]="{
    titleIcon: 'chevrons',
    titleIconColor: 'primary',
    confirmText: (isUpdateMode ? 'common.update' : 'common.save') | translate,
    cancelText: 'common.cancel' | translate,
    confirmButtonStyle: 'primary',
    confirmIcon: 'arrow-right',
    confirmIconPosition: 'end'
  }" (confirm)="save()" (cancel)="cancel()">

<form class="information-form" [formGroup]="form">
    <div class="form-content">
      <!-- related object -->
      <div class="section-title">{{"custom_fields.details" | translate}}</div>
      <div class="standard-input">
        <label for="related_object">{{
          "custom_fields.related_object" | translate
        }}</label>
        <ui-form-field type="select" [options]="related_objects" formControlName="object_type"></ui-form-field>
      </div>

      <!-- field name -->
      <div class="standard-input">
        <label for="field_name">{{
          "custom_fields.field_name" | translate
        }}</label>
        <ui-form-field type="text" formControlName="field_name"></ui-form-field>
        <div
          class="error"
          *ngIf="
            form.get('field_name')?.invalid &&
            (form.get('field_name')?.touched || form.get('field_name')?.dirty)
          "
        >
          <small *ngIf="form.get('field_name')?.hasError('required')">{{
            "validation.required" | translate
          }}</small>
        </div>
      </div>

    <!-- field type -->
      <div class="standard-input">
        <label for="field_type">{{
            "custom_fields.field_type" | translate
        }}</label>
        <ui-form-field type="select" [options]="fieldTypeOptions" formControlName="field_type"></ui-form-field>
        <div
            class="error"
            *ngIf="
            form.get('field_type')?.invalid &&
            (form.get('field_type')?.touched || form.get('field_type')?.dirty)
            "
        >
            <small *ngIf="form.get('field_type')?.hasError('required')">{{
            "validation.required" | translate
            }}</small>
        </div>
      </div>

      <!-- allowed values -->
      <div
        *ngIf="[customFieldTypes.SINGLE_SELECT, customFieldTypes.MULTI_SELECT].includes(form.get('field_type')?.value ?? '')"
        class="standard-input"
      >
        <label for="allowed_values">{{
          "custom_fields.allowed_values" | translate
        }}</label>
        <mat-chip-list #chipList formControlName="allowed_values">
          <mat-chip *ngFor="let value of allowed_values" [selectable]="true" [removable]="true" (removed)="removeAllowedValue(value)">
            {{ value }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            placeholder="Add values separated by comma"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addAllowedValue($event)"
          />
        </mat-chip-list>
        <div
          class="error"
          *ngIf="
            form.get('allowed_values')?.invalid &&
            (form.get('allowed_values')?.touched || form.get('allowed_values')?.dirty)
          "
        >
          <small *ngIf="form.get('allowed_values')?.hasError('required')">
            {{ "validation.required" | translate }}
          </small>
        </div>
      </div>

      <!-- visibility -->
      <div class="standard-input">
        <label for="visibility">{{ "custom_fields.visibility" | translate }}</label>
        <ui-form-field
          type="select"
          [options]="visibilityOptions"
          [multiple]="true"
          formControlName="visibility"
        ></ui-form-field>
      </div>

      <!-- is required -->
      <div class="standard-input checkbox-input">
        <mat-checkbox formControlName="is_required">
        </mat-checkbox>
        <label for="is_required">{{ "validation.required" | translate }}</label>
      </div>

      <!-- translations -->
       <div class="section-title">{{"common.translations" | translate}}</div>
       <div class="translations-block" formArrayName="translations">
        <div class="currency-block" *ngFor="let t of translationsControls; let i = index" [formGroupName]="i">
          <div class="form-row">
            <label class="field-label">{{ 'custom_fields.language' | translate }}</label>
            <div class="currency-select-wrapper">
              <mat-select formControlName="language" [disabled]="i === 0">
                  <mat-select-trigger>
                      <span class="tag">{{ 'common.languages.' + (t.get('language')?.value || currentLanguage) | translate }}</span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let language of languages" [value]="language" [disabled]="isLanguageOptionDisabled(language, i)">
                    {{ 'common.languages.' + language | translate }}
                  </mat-option>
              </mat-select>
            </div>
            <div class="delete-wrapper" *ngIf="i > 0">
              <ui-button
                [type]="'secondary'"
                [icon]="'delete_btn'" 
                (click)="removeLanguage(i)"
              >
              </ui-button>
            </div>
          </div>
          <div class="form-row">
            <label class="field-label">{{ 'custom_fields.field_label' | translate }}</label>
            <div class="standard-input">
              <input *ngIf="i === 0" type="text" formControlName="label" [readonly]="true" />
              <ui-form-field *ngIf="i !== 0" type="text" formControlName="label"></ui-form-field>
            </div>
          </div>
    
          <div class="form-row">
            <label class="field-label">{{ 'custom_fields.help_text' | translate }}</label>
            <div class="standard-input">
              <ui-form-field type="text" formControlName="help_text"></ui-form-field>
            </div>
          </div>
        </div>
       </div>
       <div class="add-currency" *ngIf="canAddLanguage" (click)="addLanguage()">
            <mat-icon>add</mat-icon>
            <span>{{ 'custom_fields.add_translation' | translate }}</span>
       </div>

       <div class="standard-input">
        <label for="erp_mapping_key">{{ "custom_fields.erp_mapping_key" | translate }}</label>
        <ui-form-field type="text" formControlName="erp_mapping_key"></ui-form-field>
       </div>
    </div>
  </form>
</app-shared-dialog>